/* eslint-disable @typescript-eslint/no-explicit-any */
import type { Theme } from "@mui/material/styles";

export default function Popover(theme: Theme): any {
  return { MuiPopover: { styleOverrides: { paper: { boxShadow: theme.customShadows.z12 } } } };
}
